import { useState } from 'react';
// @mui
import { styled } from '@mui/material/styles';
import { Input,TextField, Box,Slide, Button, InputAdornment, ClickAwayListener } from '@mui/material';
// utils
import cssStyles from '../../../utils/cssStyles';
// components
import Iconify from '../../../components/Iconify';
import { IconButtonAnimate } from '../../../components/animate';

// ----------------------------------------------------------------------
import React, {
  createContext,
 
  useEffect,
  useLayoutEffect,
} from "react";

import { Link, useNavigate, useLocation } from "react-router-dom";
import {searchUsers} from "../../../Dashboard/api/api";
import Autocomplete from '@mui/material/Autocomplete';
import { useDispatch, useSelector } from "react-redux";
import {
  chooseHeaderCallCustomerId
} from "../../../Kgo/reducers/reducer";





const APPBAR_MOBILE = 54;
const APPBAR_DESKTOP = 80;

const SearchbarStyle = styled('div')(({ theme }) => ({
  ...cssStyles(theme).bgBlur(),
  top: 0,
  left: 0,
  zIndex: 99,
  width: '100%',
  display: 'flex',
  position: 'absolute',
  alignItems: 'center',
  height: APPBAR_MOBILE,
  padding: theme.spacing(0, 3),
  boxShadow: theme.customShadows.z8,
  [theme.breakpoints.up('md')]: {
    height: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));



const styledAutocomplete = {
  width: 300,ml:10,mt:1 ,pt:1,
 "& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)": {
   // Default transform is "translate(14px, 20px) scale(1)""
   // This lines up the label with the initial cursor position in the input
   // after changing its padding-left.
   
 },
 "& .MuiAutocomplete-inputRoot": {
   color: "black",
   backgroundColor:'white',
   // This matches the specificity of the default styles at https://github.com/mui-org/material-ui/blob/v4.11.3/packages/material-ui-lab/src/Autocomplete/Autocomplete.js#L90
   '&[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input:first-child': {
     // Default left padding is 6px
     paddingLeft:  1
   },
   "& .MuiOutlinedInput-notchedOutline": {
     borderColor: "green"
   },
   "& #cBoxAutocomplete-label":{
     backgroundColor:'red',

     color:'red'
   },
   "&:hover .MuiOutlinedInput-notchedOutline": {
     
   },
   "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
     borderColor: "white"
   }
 }
};



const textfield = {
 "& .MuiInputBase-input.MuiAutocomplete-input": {
   color: "black",
   fontSize: 18
 },
 "& #cBoxAutocomplete-label": {
   //or could be targeted through a class
   color: "green",
   backgroundColor:'white',
 },
 "& .MuiButtonBase-root.MuiAutocomplete-clearIndicator": {
   color: "black"
 }
};






// ----------------------------------------------------------------------

export default function Searchbar() {
  const dispatch = useDispatch();

  let navigate = useNavigate();
  const { pathname } = useLocation();
  const [searchedUserList,setSearchedUserList]=React.useState([]);
  const [inputText,setInputText]=React.useState("");
  useEffect(() => {
    if(inputText.length>=2){
      const pagerInputModel = {
        "searchText": inputText
        
    }
     searchUsers(pagerInputModel).then((res)=>{
        setSearchedUserList(res.data)
      console.log(res);
     });
  
    }

  }, [inputText]);
  
  function goToDataPage(customerId) {
    // alert(pathname+" pth");
     if(pathname=="/dashboard/datapage")
       dispatch( chooseHeaderCallCustomerId(customerId));
     else
       navigate("/dashboard/datapage",{state:{customerId:customerId}});
 }
 

  const [isOpen, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen((prev) => !prev);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <div>
        {!isOpen && (
          <IconButtonAnimate onClick={handleOpen}>
            <Iconify icon={'eva:search-fill'} width={20} height={20} />
          </IconButtonAnimate>
        )}

        <Slide direction="down" in={isOpen} mountOnEnter unmountOnExit>
          <SearchbarStyle>
            {/* <Input
              autoFocus
              fullWidth
              disableUnderline
              placeholder="Müşteri Arama..."
              startAdornment={
                <InputAdornment position="start">
                  <Iconify
                    icon={'eva:search-fill'}
                    sx={{ color: 'text.disabled', width: 20, height: 20 }}
                  />
                </InputAdornment>
              }
              sx={{ mr: 1, fontWeight: 'fontWeightBold' }}
            />
            <Button variant="contained" onClick={handleClose}>
             Ara
            </Button> */}

{/* 

<Autocomplete  
  freeSolo
  autoFocus
  id="cBoxAutocomplete"
  getOptionLabel={(option) => option.name}
  onInputChange={(event, newValue) => {
    // text box value changed
    //console.log("onInputChange start");
    setInputText(newValue);
  //  alert(inputText);
    // if ((newValue).length > 3) { setInputText(newValue); }
    // else { setOptions([]); }
    //console.log("onInputChange end");
  }}
  options={searchedUserList}
  filterOptions={(options) => options}
  onChange={(event, value) => {
    goToDataPage(value.customerId); 
    setSearchedUserList([]);
    setInputText("");
    console.log(value,"ee");;}} // prints the selected value

  getOptionSelected={(option, value) => option.title === value.title}
  getOptionLabel={(option) =>
    option && option.name && option.surname
      ? option.name+ " " + option.surname + " - \n" + option.customerEmails[0]?.email
      : "Bilinmeyen sonuç"
  }
  onMouseDownCapture={(event) => {
    event.stopPropagation();
    console.log("STOPPED PROPAGATION");
  }}
  sx={styledAutocomplete}
  renderInput={(params) =><Box> <TextField autoFocus  {...params} sx={{backgroundColor:"red"}} placeholder=" Ara" size="small" fullWidth sx={textfield} /></Box>}
/> */}
{/* 
<div style={{color:'red'}}>"Test rentt"</div> */}







          </SearchbarStyle>
        </Slide>
      </div>
    </ClickAwayListener>
  );
}
